// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 789 ? "mammoth-browser" : chunkId) + "." + {"765":"a0120466","789":"eddc36a8"}[chunkId] + ".chunk.js";
};